import { Stack, Theme, Typography } from '@mui/material';
import { AuditLog } from '@oxappsec/ox-unified-audit-logger';
import { FC, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import BottomDrawer from '../../elements/BottomDrawer/BottomDrawer';
import { clearSelectedLog } from '../store-actions/audit-logs-store-actions';
import { resolveLogTypeIcon } from '../utils/audit-log-utils';
import AuditLogCard from './Cards/AuditLogCard';

const AuditLogDrawer: FC<React.PropsWithChildren<AuditLogDrawerProps>> = ({
  className,
  auditLog,
  defaultHeight,
  onResizeStop,
}) => {
  const { classes } = useStyles();

  return (
    <BottomDrawer
      className={className}
      onClose={clearSelectedLog}
      loading={false}
      defaultHeight={defaultHeight}
      onResizeStop={onResizeStop}
      title={
        auditLog && (
          <Stack direction='row' justifyContent='space-between'>
            <div className={classes.logType}>
              {resolveLogTypeIcon(auditLog.logType)}
              <Typography variant='body2' color='text.primary'>
                {auditLog.logType}
              </Typography>
            </div>
          </Stack>
        )
      }>
      {auditLog && <AuditLogCard auditLog={auditLog} />}
    </BottomDrawer>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  buttons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  logType: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  appCount: {
    color: '#5059FF',
    textAlign: 'center',
    padding: theme.spacing(0.5, 1.5),
    background:
      theme.palette.mode === 'dark'
        ? '#1C1F2A'
        : theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
  },
  appsText: {
    color: `${theme.palette.dashInventory.textColor.colorAppsText} !important`,
    whiteSpace: 'nowrap',
    fontSize: 14,
    minWidth: '5rem',
  },
}));
export interface AuditLogDrawerProps {
  auditLog: AuditLog;
  className: string;
  extras?: ReactNode;
  defaultHeight?: number;
  onResizeStop?: (height: number) => void;
}

export default AuditLogDrawer;
